import {modalController} from '@ionic/vue';
import VerificationRequiredSheet from '@/views/common/VerificationRequiredSheet.vue';

export function useVerification() {
    const presentVerificationRequired = async (text?: string) => {
        const props: Record<string, string> = {};

        if (text) {
            props.text = text;
        }

        const isWide = window.innerWidth >= 768;

        const sheet = await modalController.create({
            component: VerificationRequiredSheet,
            componentProps: props,
            mode: 'ios',
            backdropDismiss: true,
            canDismiss: true,
            cssClass: isWide
                ? 'verification-required-modal verification-required-modal--desktop'
                : 'verification-required-modal',
            ...(isWide
                ? {}
                : {
                    breakpoints: [0, 1],
                    initialBreakpoint: 1,
                    handle: true,
                }),
        });

        await sheet.present();
    };

    return {
        presentVerificationRequired,
    };
}
